import React, { Fragment } from 'react';
import FormInput from '../../../containers/shared/forms/form-input';
import FormSelect from '../../../containers/shared/forms/form-select';
import { useFetchRegionsAndCountries } from '../hooks';
export const SetupFormFields = () => {
    const { formattedCountries, formattedRegions } = useFetchRegionsAndCountries();
    return (React.createElement(Fragment, null,
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'country' }, "Country"),
            React.createElement(FormSelect, { fieldName: 'country', fieldValues: formattedCountries })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'companyName' }, "Company Name"),
            React.createElement(FormInput, { fieldName: 'companyName' })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'street1' }, "Primary Business Address"),
            React.createElement(FormInput, { fieldName: 'street1', maxLength: 50 })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'street2' }, "Optional"),
            React.createElement(FormInput, { fieldName: 'street2', maxLength: 50 })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'city' }, "City"),
            React.createElement(FormInput, { fieldName: 'city', addPadding: true })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'state' }, "Region"),
            React.createElement(FormSelect, { fieldName: 'state', fieldValues: formattedRegions })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'postalCode' }, "Postal code"),
            React.createElement(FormInput, { fieldName: 'postalCode', addPadding: true }))));
};
